const pickListService = () => {
    const arrayToPickListData = (array) => {
        const retVal = [];
        array.forEach((element) => retVal.push({ values: [element] }));
        return retVal;
    };

    const pickListDataToArray = (pickListData) => {
        const retVal = [];
        let arrayCount = 0;

        pickListData.forEach(({ values }) => {
            if (values.length > arrayCount) {
                arrayCount = values.length;
            }
        });

        for (let i = 0; i < arrayCount; i++) {
            retVal.push([]);
        }

        pickListData.forEach(({ values }) => {
            for (let i = 0; i < values.length; i++) {
                retVal[i].push(values[i]);
            }
        });
        return retVal;
    };

    return {
        arrayToPickListData,
        pickListDataToArray
    };
};

export default pickListService;
